module.exports = __webpack_public_path__ + "463b8db7909a4b4fa37c422f5cc23ae6.png";